import React from 'react';

import { appConfig } from 'config/customization';
import { UTILITIES } from 'constants/utilitiesMappers';

import EdenAuthFormWrapper from './components/EdenAuthFormWrapper';
import OthersAuthFormWrapper from './components/OthersAuthFormWrapper';

const Components = {
  [UTILITIES.eden]: EdenAuthFormWrapper,
  [UTILITIES.edelap]: OthersAuthFormWrapper,
  [UTILITIES.edes]: OthersAuthFormWrapper,
  [UTILITIES.edet]: OthersAuthFormWrapper,
  [UTILITIES.ejesa]: OthersAuthFormWrapper,
  [UTILITIES.utilityco]: OthersAuthFormWrapper
};

const Component = Components[appConfig.mappers];

const AuthFormWrapperMapper = props => <Component {...props} />;

export default AuthFormWrapperMapper;
